import styled from '@emotion/styled';
import { Box, BoxProps } from '@hover/blueprint';
import React, { useRef, useState } from 'react';
import { MuteUnmuteIcon } from '..';
import { IElementWithVideo } from '../../../interfaces/IElementWithVideo';

const StyledWrapper = styled(Box)`
  video {
    object-fit: initial;
    height: 261px;
    width: 419.5px;
  }
  &:hover {
    #mute-icon {
      display: flex;
    }
  }
`;

interface Props extends BoxProps, IElementWithVideo {}

const HeroVideoWithMuteIcon: React.FC<Props> = ({
  videoSrcs,
  poster,
  ...rest
}) => {
  const [isMuted, setIsMuted] = useState<boolean>(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  const toggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !videoRef.current.muted;
    setIsMuted(!isMuted);
  };
  return (
    <StyledWrapper
      position="absolute"
      bottom="95px"
      maxW="422px"
      left="72px"
      right="67px"
      onClick={toggleMute}
      cursor="pointer"
      zIndex={5}
      {...rest}
    >
      <MuteUnmuteIcon
        d="none"
        id="mute-icon"
        left="182px"
        top="103px"
        isMuted={isMuted}
        zIndex={10}
      />
      <video poster={poster} ref={videoRef} width="100%" autoPlay muted loop>
        {videoSrcs.map(({ src, type }) => (
          <source src={src} type={type} key={type} />
        ))}
      </video>
    </StyledWrapper>
  );
};

export default HeroVideoWithMuteIcon;
